import { parseAsFloat, createSerializer, parseAsStringLiteral } from 'nuqs';

const statsQueryParsers = {
  statsType: parseAsStringLiteral(['historic', 'actual']),
  lower: parseAsFloat,
  upper: parseAsFloat,
};

export const statsQuerySerialiser = createSerializer(statsQueryParsers);
